'use strict';

(function (root, factory) {
    if (typeof module !== 'undefined' && module.exports !== undefined) {
        module.exports = factory(root);
    } else if (typeof define !== 'undefined' && define.amd) {
        define('iURL', [], function () {
            return factory(root);
        });
    } else {
        root.iURL = factory(root);
    }
})(window || module || {}, function (root) {
    return {
        /**
         * @param {string} name
         * @return {string}
         */
        get: function get(name) {
            if (!name || !root.document.location.search) {
                return null;
            }

            var _stringWithParams = root.document.location.search.replace(/^\?/, ''),
                _params = _stringWithParams.split('&'),
                result = null,
                i = void 0,
                len = _params.length;

            for (i = 0; i < len; i++) {
                if (typeof _params[i] === 'string') {
                    var _data = _params[i].split('=');

                    if (_data[0] == name) {
                        result = _data[1] || null;
                        break;
                    }
                }
            }

            return result;
        },

        /**
         * GET params
         * @return {boolean}
         */
        hasParams: function hasParams() {
            return !!root.document.location.search.replace(/^\?/, '');
        },

        /**
         * @return {{}}
         */
        getSearchParams: function getSearchParams() {
            var data = {},
                searchString = void 0,
                searchParamsSection = void 0,
                i = void 0,
                len = void 0,
                searchParamsData = void 0;

            if (root.document.location.search) {
                searchString = root.document.location.search.replace(/^\?/, '').replace(/\&$/, '');
                searchParamsSection = searchString.split('&');
                len = searchParamsSection.length;

                for (i = 0; i < len; i++) {
                    searchParamsData = searchParamsSection[i].split('=');
                    data[searchParamsData[0]] = searchParamsData[1] || null;
                }
            }

            return data;
        }
    };
});